import { Directive, Host, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CanDeactivateService } from '../services/can-deactivate.service';
import { Subject } from 'rxjs';

@Directive({
    selector: 'form [appPromptUnsubmitted], [ngForm][appPromptUnsubmitted]'
})
export class PromptUnsubmittedDirective implements OnInit, OnDestroy {

    protected onDestroy$ = new Subject<void>();

    constructor(@Host() private form: NgForm, private canDeactivateService: CanDeactivateService) {

    }

    ngOnInit(): void {
        this.canDeactivateService.registerCanDeactivate(() => !this.hasUnsavedData(), this.onDestroy$);
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    private hasUnsavedData() {
        return !this.form.submitted && this.form.dirty;
    }
}
